/**
 * Light-theme trust badges shared between /start (Step 1 + interstitials)
 * and /checkout/plan (membership sales surface). The dark variant in
 * `src/components/GlobalFooter.tsx` is intentionally separate — it lives
 * inside the dark footer and uses different border/background tokens.
 */

import { HeartPulse, Lock, ShieldCheck, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

export function TrustBadgeRow() {
  return (
    <div
      className="flex flex-wrap justify-center gap-2 pt-1"
      role="list"
      aria-label="Trust signals"
    >
      <TrustBadge icon={HeartPulse}>HSA/FSA eligible</TrustBadge>
      <TrustBadge icon={ShieldCheck}>CLIA-certified labs</TrustBadge>
      <TrustBadge icon={Lock}>HIPAA-aligned</TrustBadge>
    </div>
  );
}

function TrustBadge({ icon: Icon, children }: { icon: LucideIcon; children: ReactNode }) {
  return (
    <span
      role="listitem"
      className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-2.5 py-1 text-[10px] font-medium text-slate-600 uppercase tracking-wider"
    >
      <Icon size={11} className="text-emerald-500" />
      {children}
    </span>
  );
}
